import { useMutation, useQueryClient } from '@tanstack/react-query';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants/networking.constants';
import { UseMutationsParams } from '@/shared/interfaces';
import { handleAxiosError } from '@/shared/utils';
import { useUiStore } from '@/store/ui';
import { ActividadInventario } from '@/erp/reportes/actividad-inventario/pages/ReporteActividadInventarioPage';
import { toast } from 'react-toastify';

const { post } = erpApi();



export const usefetchReporteActividadInventarioUsuario = ({
  navigate,
   
  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  return useMutation({
    mutationFn: fetchReporteActividadInventarioUsuario,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['IActividadInventarioUsuarios'] });

      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&(
        toast.success(customSuccessMessage ?? 'Información obtenida correctamente')
      )
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};


///* axios
export type getIActividadInventarioUsuariosParams = Partial<ActividadInventario> & {
  page?: number;
  page_size?: number;

  filterByState?: boolean;
  pais_codigo?: string;
};

export type fetchReporteActividadInventarioUsuarioParams = {
  fecha_inicio: string;
  fecha_fin: string;
  habilitar_descarga?: boolean;
};




export const fetchReporteActividadInventarioUsuario = async (data: fetchReporteActividadInventarioUsuarioParams) => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true);
  const res = await post<ActividadInventario>(
    `${urlBackend}api/v1/reporte-actividad-inventario-usuario/`,
    data,
    true
  );
  return res;
};
